var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"md-layout"},[_c('md-empty-state',{staticClass:"md-accent",attrs:{"md-icon":"lock","md-description":"You are unauthorized to access this resource"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }